// Mirrors backend/services/prose_generation/pipeline.py's mode constants —
// the exact strings the API expects/returns.
export const MODE_VERIFIED = 'verified';
export const MODE_VERIFIED_AUTOFIX = 'verified_autofix';
export const MODE_SKETCH = 'sketch';
